export const environment = {
  production: false,
  apiUrl: 'https://52.18.197.234/api-test/api',
  tessApiUrl: 'https://tess-api.tessdev.com',
};
